import React from 'react';
import { useAuthContext } from '../hooks/useAuthContext';
import Navbar from '../components/Navbar';
import AdminSectionLayout from '../components/AdminSectionLayout';
import UserProfileTab from '../components/user-settings/UserProfileTab';

const BioPage = () => {
  const { user } = useAuthContext();

  if (!user) {
    return (
      <div className="p-6">
        <h1 className="text-2xl font-semibold mb-4">My Profile</h1>
        <p>Please log in to edit your profile.</p>
      </div>
    );
  }

  return (
    <>
      <Navbar />
      <AdminSectionLayout
        title="My Profile"
        description="Manage your artist or curator profile for Artization analytics."
      >
        <UserProfileTab />
      </AdminSectionLayout>
    </>
  );
};

export default BioPage;
